import { Languages } from '../knowledge-base-common/knowledge-base-common.type';

export const languages = [Languages.RU, Languages.KK, Languages.EN];

export const langLabels = {
    [Languages.RU]: 'Русский',
    [Languages.KK]: 'Қазақша',
    [Languages.EN]: 'English',
};

export const ARTICLE_SIZE_LIMIT = 2_000;
export const RESULTS_COUNT_LIMIT = 10;
export const ASSISTANT_REPLY_DELAY = 500;

export const PHONE_LENGTH = 11;
export const MESSAGE_LENGTH = 700;
// export const EMAIL_LENGTH = 30;
